<script>
export default {
  name: "BanobagiTransactionSummary",
  props: {
    total: {
      type: [Number, String],
      default: 0
    }
  }
};
</script>

<template>
  <section class="banobagi-transaction-summary" data-test="transaction-summary">
    <!-- <div class="banobagi-transaction-summary__art" aria-hidden="true">
      <span class="banobagi-transaction-summary__gift is-large">
        <font-awesome-icon :icon="['fas', 'gift']" />
      </span>
      <span class="banobagi-transaction-summary__gift is-small">
        <font-awesome-icon :icon="['fas', 'gift']" />
      </span>
      <span class="banobagi-transaction-summary__gift is-medium">
        <font-awesome-icon :icon="['fas', 'gift']" />
      </span>
    </div> -->

    <h2 class="banobagi-transaction-summary__title">{{ $t("all") }}</h2>
    <p class="banobagi-transaction-summary__label">
      {{ $t("number_times") }}
    </p>
    <strong
      class="banobagi-transaction-summary__total"
      data-test="transaction-summary-total-value"
    >
      {{ numeralFormat(total) }}
    </strong>
  </section>
</template>

<style lang="scss" scoped>
.banobagi-transaction-summary {
  position: relative;
  display: flex;
  min-height: 172px;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 56px 24px 16px;
  border-radius: 28px;
  background: var(--light-color-low);
  color: var(--text-color);
  text-align: center;
}

.banobagi-transaction-summary__art {
  position: absolute;
  top: -8px;
  left: 50%;
  width: 132px;
  height: 88px;
  transform: translateX(-50%);
}

.banobagi-transaction-summary__gift {
  position: absolute;
  display: inline-flex;
  width: 54px;
  height: 54px;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--secondary-color);
  border-radius: 50%;
  box-shadow: 0 8px 18px rgba(95, 74, 102, 0.16);
  font-size: var(--font-title);
}

.banobagi-transaction-summary__gift.is-large {
  top: 0;
  left: 8px;
  background: #f5d7de;
  color: #b77c8d;
}

.banobagi-transaction-summary__gift.is-medium {
  top: 24px;
  right: 8px;
  background: #d8ecfa;
  color: #5c99c7;
}

.banobagi-transaction-summary__gift.is-small {
  top: 8px;
  left: 48px;
  z-index: 1;
  width: 46px;
  height: 46px;
  background: #e8dcf4;
  color: #8f70a8;
  font-size: var(--font-title-sm);
}

.banobagi-transaction-summary__title {
  margin: 0;
  font-size: var(--font-title);
  font-weight: 600;
  line-height: 1.35;
}

.banobagi-transaction-summary__label {
  margin: 4px 0 0;
  font-size: var(--font-body-lg);
  line-height: 1.4;
}

.banobagi-transaction-summary__total {
  margin-top: 4px;
  color: var(--primary-color);
  font-size: var(--font-heading);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
}
</style>
